import { H6, Paragraph, XStack, YStack } from 'tamagui'

export function Benefit({
  title,
  description,
  icon,
}: {
  title: string
  description: string
  icon: React.ReactNode
}) {
  return (
    <XStack gap="$2" items="flex-start">
      {icon}
      <YStack gap="$1" shrink={1}>
        <H6>{title}</H6>
        <Paragraph>{description}</Paragraph>
      </YStack>
    </XStack>
  )
}
